import 'shared/global';
import 'components/hero.js';
import 'components/accessibilityCarousel.js';
import brandsCarousel from 'components/brandsCarousel';
import homeShowGroupCarousel from 'carousels/homeShowGroupCarousel';
import hpConfigurator from 'carousels/hpConfigurator';
import NotificationBar from 'components/notifications/NotificationBar';
import landscapeCarousel from 'components/landscapeCarousel';
import portraitCarousel from 'components/portraitCarousel';
import { STORAGE_KEY_SHOW_PICKER_IDS } from 'components/showPicker';
import 'shared/fathomTracking';
import { getLocale } from '../services/LocalizationService';

import kidsCarousel from 'carousels/kidsCarousel';
import { UpsellBannerPartner } from 'components/upsellBanner/upsellBannerPartner';

import PartnerTrackingService from 'services/PartnerTrackingService';

// Region prefix
let _regionPrefix = CBS.Registry.region.prefix;

const appConfig = JSON.parse(document.getElementById('app-config').innerHTML);
CBS.Registry.homepage = true;

if (appConfig && appConfig.homepageConfiguratorEnabled) {
    // Initialize homepage configurator (carousels)
    hpConfigurator();
} else {
    document.querySelector('.top-components').classList.remove('loading');

    homeShowGroupCarousel(
        _regionPrefix +
            '/carousels/homepage/xhr/sectionId/{sectionId}/offset/{offset}/limit/{limit}/',
    );
}

// Trigger Braze view_page events.
try {
    // The second time a user views the home page after trial start, the view_page event
    // is triggered with params "App Download Prompt" = True.
    // During the sign up, the profile selection mounts on home page and the counter is initialized then to 0.
    const user_profile_id = CBS.Registry.user['profile_id'];
    const countKey = 'home_page_on_boarding_count_' + String(user_profile_id);
    const brazeCampaignParams = { screenName: 'home' };
    if (user_profile_id > 0) {
        if (sessionStorage.getItem(countKey) === '0') {
            sessionStorage.setItem(countKey, '1');
        } else if (sessionStorage.getItem(countKey) === '1') {
            sessionStorage.setItem(countKey, '2');
            brazeCampaignParams['App Download Prompt'] = true;
        }

        if (CBS.Registry.Features.braze_sdk === true)
            import('shared/braze_events/events').then(({ onHomePageView }) =>
                onHomePageView('/', brazeCampaignParams),
            );
    }
} catch (e) {
    console.error(
        CBS.Registry.Features.braze_sdk === true ? 'Braze homepage error' : 'Homepage error',
        e,
    );
}

try {
    brandsCarousel({
        parentContainer: $('#brands-carousel'),
        options: {
            endPoint: _regionPrefix + '/carousels/homepage/brands/offset/{offset}/limit/{limit}/',
        },
    });
} catch (e) {}

try {
    kidsCarousel(CBS.Registry.user.profile_type);
} catch (e) {
    console.error('Top Stories carousel failed to load: ', e);
}

try {
    let banner = new UpsellBannerPartner();
    document.addEventListener('DOMContentLoaded', () => {
        banner.init();
    });
} catch (e) {
    // ignore
}

if (!appConfig || !appConfig.homepageConfiguratorEnabled) {
    try {
        landscapeCarousel({
            parentContainer: $('#keep-watching-carousel'),
            options: {
                endPoint:
                    _regionPrefix +
                    '/carousels/homepage/keepwatching/offset/{offset}/limit/{limit}/',
                reloadPoint:
                    _regionPrefix +
                    '/carousels/homepage/keepwatching/offset/{offset}/limit/{limit}/',
                editPoint: _regionPrefix + '/video/show/delete.json?showId=',
                trackingParam: 'trackEditKW',
            },
        });
    } catch (e) {
        console.error('Keep watching carousel upper failed to load', e);
    }

    try {
        portraitCarousel({
            parentContainer: $('#movies-carousel'),
            options: {
                endPoint: _regionPrefix + '/movies/xhr/moviepage/movies/',
            },
        });
    } catch (e) {
        console.error('Movies carousel upper failed to load', e);
    }

    try {
        portraitCarousel({
            parentContainer: $('#trending-movies-carousel'),
        });
    } catch (e) {
        console.error('Trending Movies carousel upper failed to load', e);
    }

    try {
        let params = {
            parentContainer: $('#trending-recommended-for-you-carousel'),
        };

        let showPickerIds = sessionStorage.getItem(STORAGE_KEY_SHOW_PICKER_IDS);
        if (showPickerIds) {
            let options = {
                options: {
                    endPoint: '/shows/picker/xhr/showids/' + showPickerIds + '/',
                },
            };
            Object.assign(params, options);
            sessionStorage.removeItem(STORAGE_KEY_SHOW_PICKER_IDS);
        }
        portraitCarousel(params);
    } catch (e) {
        console.error('Trending / Recommended For You carousel failed to load: ', e);
    }
}

// Guest partner account creation success message
const partner = new URLSearchParams(window.location.search).get('partner');

if (partner) {
    const notificationBar = new NotificationBar();
    notificationBar.showMessage(
        getLocale(
            'your_paramountplus_account_has_been_successfully_created_please_sign_in_with_any_device_to_access',
        ),
        true,
    );
}

try {
    let partnerTrackingService = new PartnerTrackingService();
    partnerTrackingService.trackHomepage();
} catch (e) {
    console.error('Partner Tracking Error: ' + e);
}
